import { useEffect, useState } from "react";
import api from "../lib/api";

const roleTint = {
  creator: "text-nexus-pink border-nexus-pink/30 bg-nexus-pink/10",
  brand: "text-nexus-blue border-nexus-blue/30 bg-nexus-blue/10",
};

function Face({ s, className = "" }) {
  return s.avatar_url ? (
    <img src={s.avatar_url} alt="" className={`rounded-full object-cover ring-2 ring-[#060608] ${className}`} />
  ) : (
    <div className={`rounded-full nexus-gradient ring-2 ring-[#060608] flex items-center justify-center font-display font-bold text-white text-[10px] ${className}`}>
      {(s.name || "?").trim().charAt(0).toUpperCase()}
    </div>
  );
}

function LiveDot() {
  return (
    <span className="relative flex h-2 w-2 shrink-0">
      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-nexus-pink opacity-75" />
      <span className="relative inline-flex rounded-full h-2 w-2 bg-nexus-pink" />
    </span>
  );
}

/** Inline "recently joined" strip for the hero — sits in the page flow, rotates through real signups every 5s. */
export default function RecentSignups() {
  const [signups, setSignups] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const load = () => api.get("/homepage/recent-signups?limit=12").then((r) => setSignups(r.data?.signups || [])).catch(() => {});
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    if (signups.length <= 1) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % signups.length), 5000);
    return () => clearInterval(t);
  }, [signups.length]);

  if (signups.length === 0) return null;
  const s = signups[idx % signups.length];
  const faces = signups.slice(0, 4);

  return (
    <div
      data-testid="recent-signups-strip"
      className="inline-flex items-center gap-3 rounded-full border border-white/10 bg-white/[0.03] backdrop-blur-sm pl-2 pr-4 py-1.5 max-w-full"
    >
      <div className="flex -space-x-2 shrink-0">
        {faces.map((f) => <Face key={f.id} s={f} className="w-7 h-7" />)}
      </div>
      <LiveDot />
      <div key={s.id} className="min-w-0 text-[12px] text-zinc-300 animate-fade-up flex items-center gap-2 truncate" data-testid="recent-signup-current">
        <span className="font-semibold text-white truncate">{s.name}</span>
        <span className={`text-[8px] uppercase tracking-widest px-1.5 py-0.5 rounded border shrink-0 ${roleTint[s.role] || "bg-white/5 text-zinc-400 border-white/10"}`}>{s.role}</span>
        <span className="text-zinc-500 truncate hidden sm:inline">{s.detail ? `· ${s.detail}` : "just joined"}</span>
        <span className="text-zinc-600 shrink-0">· {String(s.when || "").toLowerCase()}</span>
      </div>
    </div>
  );
}
